import {
  useIsGuestOfAssetWorkspace,
  useWorkspaceAsset,
} from '@gripp/shared-logic';
import { SlideAction, useSlideLayout } from '@gripp/shared-ui';
import { Icon } from 'libs/shared-ui/src/components/crop-circle/icons/Icon';
import { Pressable, StyleSheet, View } from 'react-native';
import { useLocation, useNavigate } from 'react-router';
import { isActivityOrEditPage, RoutineSubmitSource } from '../assetUtils';

export const AssetRoutinesHeader = ({
  assetId,
  issueId,
}: {
  assetId: string;
  issueId?: string;
}) => {
  const { onSlideChange, prepareSlideTransition } = useSlideLayout();
  const location = useLocation();
  const navigate = useNavigate();
  const { workspaceAsset } = useWorkspaceAsset(assetId);
  const assetWorkspaceId = workspaceAsset?.workspace?.id;
  // Off the allowlist for a guest: this gear leads to the assign/rearrange
  // page (routines/edit), which stays behind AssetSubRouteGuestGate, so
  // showing it to a guest would be a dead end.
  const isGuestOfAssetWorkspace = useIsGuestOfAssetWorkspace(assetWorkspaceId);

  const onAssetEdit = async () => {
    if (/\/routines\/edit\/?$/.test(location.pathname)) {
      return;
    }

    const basePath = issueId
      ? `/activities/${issueId}/asset/${assetId}/routines`
      : `/assets/${assetId}/routines`;
    const isRoutinesOverviewPage = /\/routines(?:\/all)?\/?$/.test(
      location.pathname
    );

    if (isRoutinesOverviewPage) {
      prepareSlideTransition(SlideAction.NEXT);
      navigate(`${basePath}/edit`, {
        state: {
          from: RoutineSubmitSource.RoutinesList,
          routinePanelReturnPath: `${location.pathname}${location.search}`,
          slideLayoutInitialTransition: SlideAction.NEXT,
        },
      });
      return;
    }

    if (!isActivityOrEditPage(location)) {
      await onSlideChange(SlideAction.NEXT);
    }

    navigate(`${basePath}/edit`);
  };

  if (isGuestOfAssetWorkspace) {
    return null;
  }

  return (
    <View style={styles.filtersContainer}>
      <Pressable onPress={onAssetEdit}>
        <Icon name="Settings" size={24} />
      </Pressable>
    </View>
  );
};

const styles = StyleSheet.create({
  filtersContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 16,
  },
});
